







































import { Component, Vue } from "vue-property-decorator";
import { authService } from "../api/authentication/authentication.api";

@Component
export default class ForgotPassword extends Vue {
  identifier: string = "";

  async handle() {
    try {
      await this.validate();
      await this.requestWrapper(authService.forgotPassword({ identifier: this.identifier }));
      const payload = this.makeOTPScreenPayload({
        identifiers: [this.identifier],
        useEmail: true,
        shadow: true,
        routeName: "ResetPasswordScreen",
        isHashed: true
      });

      this.$router.push({ name: "OTPScreen", params: { hash: payload } });
    } catch (error) {
      this.handleError(error);
    }
  }
}
